const GENERIC_EVENT = 'generic.event';

const EDAP_EVENTS = {
    MAP_SELECTED: 'map.selected', // when users clicks on fullscreen button
    MAP_PRESENTED: 'map.presented', // when map has loaded
    MAP_PIN_SELECTED: 'map_pin.selected', // on marker click
    MAP_MOVE_SELECTED: 'map_move.selected', // when the map has been dragged
    MAP_ZOOM_IN_SELECTED: 'map_zoom_in.selected', // when the user has zoomed in
    MAP_ZOOM_OUT_SELECTED: 'map_zoom_out.selected', // when the user has zoomed out
};

const triggerEdapEventWithContext = (context, event, fields) => {
    if (context && context.trigger) {
        context.trigger(event, fields);
    }
};

export {GENERIC_EVENT, EDAP_EVENTS, triggerEdapEventWithContext};
